
import { mapState } from 'vuex'
import vipSettings from '~/mixins/pages/mission-control/vipSettings'
export default {
    name: 'Theme2MobilePlayerProfile',
    mixins: [vipSettings],
    data() {
        return {
            tab: 0,
            formNickname: {
                nickname: '',
            },
            editNickname: false,
            updateLoading: false,
        }
    },
    computed: {
        ...mapState({
            player: (state) => state.player.player,
        }),
    },
    watch: {
        tab(value) {
            if (value === 0) this.$router.push({ query: {} })
            else this.$router.push({ query: { tab: value } })
        },
    },
    mounted() {
        if (
            this.$route.query.tab &&
            this.$route.query.tab === '1' &&
            this.isVipActive
        ) {
            this.tab = 1
        }
    },
    methods: {
        showEditNickname() {
            if (!this.editNickname) {
                this.formNickname.nickname = this.player.nickname
                this.editNickname = !this.editNickname
            } else {
                this.updateNickname()
            }
        },
        async updateNickname() {
            if (
                this.formNickname.nickname &&
                this.formNickname.nickname !== this.player.nickname
            ) {
                this.updateLoading = true
                await this.$store.dispatch(
                    'themes/player/doUpdatePlayerProfile',
                    {
                        ...this.formNickname,
                    }
                )
                this.updateLoading = false
            }
            this.editNickname = false
        },
    },
}
